import { Col, Row } from 'reactstrap';
import { useAppSelector } from '../../../../../app/hooks';

export const KycPreview = () => {
  const { data } = useAppSelector((state) => state.userDetails);

  return (
    <>
      <Row>
        <Col className='d-flex gap-3 '>
          STATUS: {data?.kycStatus?.sumsubStatus}
        </Col>
      </Row>
    </>
  );
};
